import React from "react";

type Props = {
  prevPrice: number;
  currentPrice: number;
  isGreen?: boolean;
  isRightPrevPrice?: boolean;
  size?: number;
  style?: React.CSSProperties
};

const ProductPrice = ({
  prevPrice,
  currentPrice,
  isGreen = false,
  isRightPrevPrice = false,
  size = 16,
  style = {}
}: Props) => {
  const ProductPriceStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: isRightPrevPrice ? "row-reverse" : "row",
    gap: "5px",
    fontSize: `${size}px`,
    ...(style && style)
  };

  const PrevPriceStyle: React.CSSProperties = {
    textDecoration: "line-through",
    color: "#747474",
  };

  const CurrentPriceStyle: React.CSSProperties = {
    fontWeight: "600",
    color: isGreen ? "#006633" : "#363636",
  };

  return (
    <div style={ProductPriceStyle}>
      <div style={PrevPriceStyle}>€{prevPrice}</div>
      <div style={CurrentPriceStyle}>€{currentPrice}</div>
    </div>
  );
};

export default ProductPrice;
